<script setup lang="ts">
import type { NuxtError } from "nuxt/app"

defineProps<{ error: NuxtError<unknown> }>()

const handleError = () => clearError({ redirect: "/" })
</script>

<template>
	<NuxtLayout name="errorpage">
		<NotFoundError v-if="error?.statusCode === 404" />
		<div
			v-else
			class="prose"
		>
			<OmnectHeading
				title="Oh no :()"
				size="xl"
			/>
			<p>{{ error?.statusCode }}</p>
			<p>{{ error?.message }}</p>
		<UButton
			data-cy="clear-errors"
			@click="handleError"
		>
			Clear errors
		</UButton>
		</div>
	</NuxtLayout>
</template>
